import React from 'react';
import { useHistory } from 'react-router-dom';
import errorImg from '../assets/error.png';

const Error = () => {
    const history = useHistory();
    const handleClick = () => {
        history.push('/')
    }
    return (
        <div className="flex flex-col w-full h-screen justify-center items-center">
            <img className="w-96 object-contain" src={errorImg} alt="error" />
            <button type="button" className="text-white bg-indigo-700 hover:bg-indigo-800 focus:ring-4 focus:ring-indigo-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-3 mb-3" onClick={handleClick}>Go to home</button>
        </div>
    )
}

export default Error
